var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('KedvezmenyekBase',[_c('v-layout',{ref:"kedvezmeny",staticStyle:{"max-width":"100%"},attrs:{"slot":"kedvezmeny","row":"","wrap":""},slot:"kedvezmeny"},[_c('BnFormField',{attrs:{"attributes":_vm.muszaki_vizsga_180_napon_belul}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }